type Props = {
  style?: any;
};

export default function Divider({ style }: Props) {
  return (
    <div className="mt-4 mb-4" style={style}>
      <div className="w-full border-t border-gray-300" />
    </div>
  );
}
